exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-file {\n    opacity: 0; /* invisible but it's there! */\n    width: 100%;\n    height: 20px;\n    position: absolute;\n    cursor: pointer;\n}\n.filebox {\n    cursor: pointer;\n}\n", ""]);

// exports
